export default "__VITE_ASSET__Bmgy5K_s__"